async function fetchCart() {
    let cartData;
    await $.ajax({
      dataType: "json",
      url: `${window.Shopify.routes.root + "cart.js"}`,
      success: function (data) {
        cartData = data;
      },
    });
    return cartData;
  }
  
  async function removeProcessingFees() {
    const cartData = await fetchCart();
    let lineItems =  cartData.items;
    // console.log(lineItems)
    // console.log('line items ----')
    const rItems = []
    if (lineItems.length > 0){
       lineItems.map((lineItem) => {
         if (lineItem.product_id == 7934580261030){
           rItems.push(lineItem);
         }
       });
      if (rItems.length > 0){
        await removeProcessingFeesQty(rItems, 0);
      }
    }
  }
  
  async function removeProcessingFeesQty(products, qty) {
    qty = parseInt(qty);
    const newObj = {};
    products.forEach((item) => {
      newObj[item.key.toString()] = qty;
    });
    try {
      await jQuery.post(window.Shopify.routes.root + "cart/update.js", {
        updates: newObj,
      });
    } catch (error) {
      console.log(error);
    } finally {
      window.location.reload()
    }
  }
  
  if (window.location.href.includes("/cart")) {
    removeProcessingFees();
  }